import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './a-button.component';
import { LoaderModule } from '../a-loader/a-loader.module';

@NgModule({
    declarations: [ButtonComponent],
    imports: [CommonModule, LoaderModule],
    exports: [ButtonComponent],
})
export class ButtonModule {}
